<button class="px-4 h-9 rounded btn bg-{{color}} text-{{size}} flex items-center justify-center gap-2" type="{{type}}" (click)="buttonClick()">
    {{ text }}
    <ng-content *ngIf="showIcon">

    </ng-content>
</button>